export const API_GATEWAY_BASE_URL =  process.env.REACT_APP_API_GATEWAY_BASE_URL;
export const DEPLOYMENT_REGION = process.env.REACT_APP_DEPLOYMENT_REGION;

export const KEY_CLOAK_URL = process.env.REACT_APP_KEY_CLOAK_URL
export const KEY_CLOAK_CLIENT_ID = process.env.REACT_APP_KEY_CLOAK_CLIENT_ID;
export const KEY_CLOAK_LOGOUT_URL = process.env.REACT_APP_KEY_CLOAK_LOGOUT_URL

export const COGNITO_REGION = process.env.REACT_APP_COGNITO_REGION;
export const COGNITO_USERPOOL_ID = process.env.REACT_APP_COGNITO_USERPOOL_ID;
export const COGNITO_DOMAIN= process.env.REACT_APP_COGNITO_DOMAIN;
export const COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const COGNITO_SIGN_IN_URL = process.env.REACT_APP_HOME_URL;
export const COGNITO_SIGN_OUT_URL = process.env.REACT_APP_LOGOUT_URL;
export const ACCESS_USER_TYPE = process.env.REACT_APP_ACCESS_USER_TYPE;
export const ACCESS_USER_FEATURELIST = process.env.REACT_APP_ACCESS_USER_FEATURELIST

export const DEFAULT_DAYS_AUDITLOGS_DATA = process.env.REACT_APP_DEFAULT_DAYS_AUDITLOGS_DATA;
export const DEFAULT_DAYS_UPLOADEDFILES_DATA = process.env.REACT_APP_DEFAULT_DAYS_UPLOADEDFILES_DATA;
export const MAX_DOWNLOAD_BYTES = 1024 * 1024 * 1024; //1GB
export const SCM_DESTINATION_PATH = JSON.parse(process.env.REACT_APP_SCM_DESTINATIONPATHS)
